import { Injectable } from '@angular/core';
import { SearchRoleFilter } from '../pages/roles/models/search-role-filter.model';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { SecurityGroup, SecurityGroupPagingModel } from '../pages/roles/models/security-group.model';
import { LocationInformation } from 'src/app/shared/models/location.model';
import { ChemicalDbPermissionModel } from '../pages/roles/models/permission.model';
import { UserGroupInfo } from '../pages/roles/role-add-edit/role-add-edit.component';
import { AddMemberToRoleRequest, EmployeeResponseModel } from '../pages/user/models/user-model';
import { SearchEmployeeFilter } from '../pages/user/models/search-emplyee-filter';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseService {
  public getSecurityGroupsPaging(request: SearchRoleFilter): Observable<SecurityGroupPagingModel> {
    return this.get('admin/role-paging', request);
  }

  public deleteRoleMember(data: any): Observable<boolean> {
    return this.post('admin/role/members/delete', data);
  }

  public deleteRole(ids: number[]): Observable<boolean> {
    return this.post('admin/role/delete', ids);
  }

  public getRoleMemberPaging(roleId: number, request: SearchRoleFilter): Observable<any> {
    return this.get(`admin/role/${roleId}/members-paging`, request);
  }

  public getSecurityGroups(
    includeLogRole?: boolean,
    includeDuplicate?: boolean,
    searchTerms?: string,
  ): Observable<SecurityGroup[]> {
    return this.get('admin/role', {
      includeLogRole,
      includeDuplicate,
      searchTerms,
    });
  }

  public getPermissionByRole(roleId: string): Observable<ChemicalDbPermissionModel[]> {
    return this.get(`admin/role/permissions/${roleId}`);
  }

  public getManageableLocationByUserGroupId(userGroupId: number): Observable<LocationInformation[]> {
    return this.get(`admin/role/${userGroupId}/manageable-locations`, userGroupId);
  }

  public getManageableUserGroupsByUserGroupId(userGroupId: number): Observable<UserGroupInfo[]> {
    return this.get(`admin/role/${userGroupId}/manageable-roles`, userGroupId);
  }

  public getPermisionByRole(roleId: string): Observable<ChemicalDbPermissionModel[]> {
    return this.get(`admin/role/permissions/${roleId}`);
  }

  public updatePermissionByRole(data: ChemicalDbPermissionModel): Observable<boolean> {
    return this.post('admin/role/permissions', data);
  }

  public addMemberToRole(data: AddMemberToRoleRequest): Observable<boolean> {
    return this.post('admin/role/members/add', data);
  }

  public updateRole(data: SecurityGroup): Observable<number> {
    return this.put('admin/role', data);
  }

  public updateAccessManageLocationsForUserGroup(userGroupId: number, locationIds: string[]): Observable<boolean> {
    return this.put(`admin/role/${userGroupId}/manageable-locations`, locationIds);
  }

  public updateAccessManageUserGroupsForUserGroup(
    userGroupId: number,
    managedUserGroupIds: number[],
  ): Observable<boolean> {
    return this.put(`admin/role/${userGroupId}/manageable-roles`, managedUserGroupIds);
  }

  public createRole(data: SecurityGroup): Observable<number> {
    return this.post('admin/role', data);
  }

  public searchEmployeesByMultipleParam(
    filter: SearchEmployeeFilter,
    ignoreLoading = false,
  ): Observable<EmployeeResponseModel> {
    return this.post(`admin/employee/search?ignoreLoading=${ignoreLoading}`, filter);
  }
}
